var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm._t("before-title"),
      _vm._v(" "),
      _vm.title ? _c("h1", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _vm._v(" "),
      _vm._t("after-title"),
      _vm._v(" "),
      _vm.subtitle
        ? _c("p", {
            staticClass: "lead",
            domProps: { innerHTML: _vm._s(_vm.subtitle) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }